<template>
  <div class="betRecord-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('投注记录') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="game-type-nav">
      <div :class="{'game-item': true, 'active': name === item.name}" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">{{ item.name }}</div>
    </div>
    <div class="date-nav">
      <div :class="{'date-item': true, 'active': date === item.type}" v-for="(item, index) in dateName" :key="index" @click="changtype('date', item.type)">{{item.name}}</div>
    </div>
    <div class="content">
      <!-- 筛选条件 -->
<!--      <div class="saibox">-->
<!--        <div :class="{'sai': true, 'active': showXuan === 1 }" @click="showPopup(1)">{{ name }}</div>-->
<!--        <div :class="{'sai': true, 'active': showXuan === 2 }" @click="showPopup(2)">{{ dateName[date] }}</div>-->
<!--      </div>-->

      <div class="record-summary">
        <div class="summary-item">
          总投注额: <span>{{ total_huizong.total_touzhu || '0.00' }}</span>
        </div>
        <div class="summary-item">
          总盈利: <span>{{ total_huizong.total_zongyingli || '0.00' }}</span>
        </div>
        <div class="summary-item">
          有效流水: <span>{{ total_huizong.total_youixiaoliushui || '0.00' }}</span>
        </div>
        <div class="summary-item">
          期数: <span>{{ total_huizong.total_qishu || 0 }}</span>
        </div>
      </div>
      <van-list style="margin-top: 10px; padding-bottom: 20px" :finished-text="$t('没有更多了')" offset="300" v-model="loading" :finished="list.length == pageData.total" @load="getData" v-if="list.length > 0">
        <van-cell v-for="(item, index) in list" :key="index" @click="jumpDetailPage(item.youxi_id)">
          <div class="cell-info">
            <div class="game-name">{{ item.plays ? item.plays : item.Code }}</div>
            <div class="num-list">
              <div class="num-item">
                投注：<span>{{ item.bet_amount }}</span>
              </div>
              <div class="num-item">
                输赢：<span>{{ item.win_loss }}</span>
              </div>
            </div>
          </div>
          <div class="cell-info cell-bottom">
            <div class="text order">{{ $t('订单号') }}：{{ item.bet_id }}</div>
            <div class="text">{{ item.bet_time }}</div>
          </div>
        </van-cell>
      </van-list>
      <div v-else style="margin-top: 3rem; text-align: center">
        <img src="/static/image/new/mine/mescroll-empty.png" style="width: 3.68rem;" alt="" />
        <div style="font-size: .37rem;color: #999;margin-top: .43rem">{{ $t('空空如也') }}</div>
      </div>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="popup" position="bottom" :style="{ height: 'calc(100% - 1.9rem - 46px)' }">
      <div class="lisg" v-if="showXuan == 1">
        <div class="bs" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">
          <div :class="api_type == item.platname ? 'lisga act' : 'lisga'">{{ item.name }}</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 2">
        <div class="bs" @click="changtype('date', 1)">
          <div :class="date == 1 ? 'lisga act' : 'lisga'">{{ $t('今日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 2)">
          <div :class="date == 2 ? 'lisga act' : 'lisga'">{{ $t('近7日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 3)">
          <div :class="date == 3 ? 'lisga act' : 'lisga'">{{ $t('近15日') }}</div>
        </div>
        <div class="bs" @click="changtype('date', 4)">
          <div :class="date == 4 ? 'lisga act' : 'lisga'">{{ $t('近30日') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'betRecord',
  data() {
    return {
      date: 4,
      list: [],
      pageData: {},
      page: 1,
      statuType: [this.$t('无效注单'), this.$t('已结算'), this.$t('未结算')],
      dogameLis: [],
      api_type: '',
      loading: false,
      name: this.$t('全部'),
      show: false,
      dateName: [
        {
          type: 1,
          name: this.$t('今日'),
        },
        {
          type: 2,
          name: this.$t('近7日'),
        },
        {
          type: 3,
          name: this.$t('近15日'),
        },
        {
          type: 4,
          name: this.$t('近30日'),
        },
      ],
      popup: false,
      showXuan: 1, //1平台选择 2 日期选择

      total_huizong: {}
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getData();
  },
  methods: {
    changDogame(name, type) {
      let that = this;
      that.name = name;
      that.api_type = type;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    changtype(name, val) {
      let that = this;
      that[name] = val;
      that.popup = false;
      that.page = 1;
      that.getData();
    },
    showPopup(val) {
      this.popup = true;
      this.showXuan = val;
    },
    openOrclose() {
      this.show = !this.show;
    },
    changtab() {
      let that = this;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(async (res) => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          const list = res.data
          const name_arr = []
          for (let i = 0; i < list.length; i++) {
            name_arr.push(list[i].name)
          }
          const text = await translateText(name_arr);
          text.forEach((item, index) => {
            list[index].name = item
          })
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: that.$store.state.appInfo.title, platname: 'OWN' });
          that.dogameLis.unshift({ name: this.$t('全部'), platname: '' });

        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getData();
    },

    // 获取交易记录
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;
        return;
      }
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/betrecord', info)
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data.list;
            if (that.page == 1) {
              that.list = res.data.list.data;
              this.total_huizong = res.data.total_huizong
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.list.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
    jumpDetailPage(id) {
      this.$router.push({
        path: '/betDetail',
        query: {
          id: id
        }
      });
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.betRecord-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .game-type-nav {
    display: flex;
    align-items: center;
    overflow: auto;
    padding-bottom: .12rem;
    margin: 0 .4rem;
    .game-item {
      width: 2.4rem;
      height: 1.07rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.10);
      border: .03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      flex-shrink: 0;
      margin-right: .27rem;
      font-size: 0.43rem;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
        border-color: #2E0B71;
      }
    }
  }
  .date-nav {
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    padding: .2rem 0 .3rem;
    margin: 0 .4rem;
    .date-item {
      font-size: 0.37rem;
      margin-right: 1.23rem;
      flex-shrink: 0;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #9A3CFF;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: -0.15rem;
          left: 0;
          right: 0;
          margin: auto;
          width: 0.41rem;
          height: .08rem;
          border-radius: .05rem;
          background: #9A3CFF;
        }
      }
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: .2rem .4rem 0;
    .record-summary {
      background-image: url("/static/image/new/mine/bet-record-bg.png");
      width: 100%;
      height: 1.84rem;
      background-size: 100% 100%;
      padding: .27rem;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: space-between;
      .summary-item {
        width: 65%;
        font-size: 0.32rem;
        span {
          font-size: 0.37rem;
          font-weight: bold;
          font-family: Gilroy;
        }
        &:nth-child(2n+2) {
         width: 35%;

        }
      }
    }
    .saibox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      box-sizing: border-box;
      margin: .2rem 0;
      background: rgba(255, 255, 255, 0.10);
      border: .03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      .sai {
        width: 50%;
        height: 1.33rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.43rem;
        &.active {
          background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
          border-color: #2E0B71;
          border-radius: .21rem;
          font-weight: bold;
        }
      }
    }
    .van-cell {
      background: rgba(255, 255, 255, 0.10) !important;
      border: .03rem solid rgba(255, 255, 255, 0.10);
      margin-bottom: .27rem;
      border-radius: .19rem;
      padding: .27rem;
      height: 1.79rem;
      &::after {
        border: none !important;
      }
     .cell-info {
       display: flex;
       align-items: center;
       justify-content: space-between;
       .game-name {
         font-weight: bold;
         font-size: 0.37rem;
         color: #4858FF;
       }
       .num-list {
         display: flex;
         align-items: center;
         .num-item {
           margin-left: .27rem;
           font-size: 0.32rem;
           span {
             color: #4858FF;
           }
         }
       }
       .text {
         font-size: 0.32rem;
         color: #999999;
       }
     }
     .cell-bottom {
       margin-top: .1rem;
     }
    }
    .van-cell__value {
      color: #fff !important;
    }

  }
}
.van-popup {
  background: #191919 !important;
  border: .03rem solid rgba(255, 255, 255, 0.10);
}
.lisg {
  box-sizing: border-box;
  padding: .32rem .4rem;
  display: flex;
  flex-wrap: wrap;
  .bs {
    width: 2.08rem;
    height: 1.07rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: .2rem;
    margin-right: .26rem;
    &:nth-child(4n+4) {
      margin-right: 0;
    }
    .lisga {
      width: 100%;
      padding: 0 .1rem;
      border: .03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      height: 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.37rem;
      text-align: center;
    }
    .lisga.act {
      background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
      border-color: #2E0B71;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/betRecord.vue